<template>
  <div class="act-form">

    <table>
      <tr class="top">
        <td colspan="2">
          <table style="text-align: right">
            <tr>
              <td>
                <img src="progress.jpg" style="width: 300px;display: block;text-align:left" />
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr style="text-align: center">
        <td>
          <span style="size: 70pt; font-weight: bold;">DƏYMİŞ ZƏRƏRİN HESABLANMASINA DAİR AKT
          </span><br>
          <span style="size: 65pt; font-weight: bold;">İş # : {{ victimParticipant.dispClaimNumber }}
          </span>
        </td>
      </tr>

      <table>
        <table class="tables">
          <tr v-if="this.itemPolicyType ===1">
            <th>Tarix</th>
            <th>Marka</th>
            <th>Ban</th>
            <th>D.Q.N</th>
            <th>Buraxılış ili</th>
            <th>Rəngi</th>
          </tr>
          <tr v-if="this.itemPolicyType ===1">
            <td width="130">{{ this.createDate }}</td>
            <td>{{ victimParticipant.brandModel }}</td>
            <td width="180">{{ victimParticipant.vin }}</td>
            <td width="130">{{ victimParticipant.regNumber }}</td>
            <td width="130" style="text-align:center">{{ victimParticipant.productionYear }}</td>
            <td></td>
          </tr>
        </table>
      </table>
      <br>
      <table class="tables">
        <tr>
          <th>N#</th>
          <th>{{this.itemPolicyType === 1 ? 'Ehtiyyat hissələri' : 'Zərər dəymiş hissələr'}}</th>
          <th>Sayı</th>
          <th>Qiymət</th>
          <th>Cəmi</th>
        </tr>
        <tr v-for="(item, i) in spareParts" :key="i">
          <td width="50">{{ i + 1 }}</td>
          <td>{{ item.partName }}</td>
          <td width="120" style="text-align:center">{{ item.count }}</td>
          <td width="120" style="text-align:right">{{ item.price }}</td>
          <td width="120" style="text-align:right">{{ item.priceSum }}</td>
        </tr>
        <tr>
          <td colspan="4" style="text-align:right;">Cəmi:</td>
          <td style="text-align:right">{{ this.spareTotalSum }}</td>
        </tr>
      </table>
      <br>
      <table class="tables">
        <tr>
          <th>N#</th>
          <th>

          </th>
          <th>Qeyd</th>
          <th>Qiymət</th>
        </tr>
        <tr v-for="(item, i) in repairStages" :key="i">
          <td width="50">{{ i + 1 }}</td>
          <td width="350">{{ item.stageName }}</td>
          <td>{{ item.notes }}</td>
          <td width="120" style="text-align:right">{{ item.price }}</td>
        </tr>
        <tr>
          <td colspan="3" style="text-align:right;">Cəmi:</td>
          <td style="text-align:right">{{ this.repairTotalSum }}</td>
        </tr>
        <tr>
          <td>

          </td>
        </tr>
        <tr>
          <td colspan="3" style="text-align:right;font-weight: bold;font-size: 20pt;">Yekun məbləğ:</td>
          <td style="font-weight: bold;font-size: 20pt;text-align:right">{{ this.totalSum }}</td>
        </tr>

      </table>

      <table>

        <tr id="heading" class="heading">
          <td><span>Tərtib edən</span></td>

        </tr>
        <table class="tbl">

          <tr>
            <span class="created">Zərərlərin qiymətləndirmə şöbəsinin mütəxəssisi : </span><br>
            <span class="created" style="font-weight: bold;">{{ this.createUserName }}</span><br>
            <span class="created">İmza : </span><br>
            <span    v-if="this.itemPolicyType !== 1" class="created">Tarix : {{ this.createDate }} </span><br>
         
          </tr>

        </table>
        <!-- <table class="tbl">
          <tr>
            <span class="tb-left-position">Zərərlərin qiymətləndirmə şöbəsinin mütəxəssisi: </span>
            <span class="tb-left-name">{{ this.createUserName }}</span>
            <span class="tb-left-signer">İmza</span>
          </tr>
        </table> -->
      </table>
    </table>
  </div>
</template>

<script>
import { DateToString } from "../../services/helper";
export default {

  components: {
  },
  props: {
    repair: Array,
    spare: Array,
    victim: Object,
    total: Number,
    policyType: Number
  },
  data() {
    return {
      repairStages: this.repair,
      spareParts: this.spare,
      totalSum: this.total,
      itemPolicyType: this.policyType,
      spareLoading: false,
      victimParticipant: this.victim,
      search: "",
      spareSum: 0,
      repairSum: 0,
      createDate: null,
      createUserName: null
    };
  },
  computed: {
    spareTotalSum() {
      let sum = 0;
      for (let i = 0; i < this.spareParts.length; i++) {
        sum += this.spareParts[i].priceSum;
      }
      return sum;
    },
    repairTotalSum() {
      let sum = 0;
      for (let i = 0; i < this.repairStages.length; i++) {
        sum += this.repairStages[i].price;
      }
      return sum;
    }
  },
  methods: {
    updateRepairStage(index, newValue) {
      this.$set(this.repairStages, index, newValue);
    }
  }
  ,
  watch: {
    repair(newValue) {
    this.repairStages = [...newValue];
  },
    spare() {
      this.spareParts = this.spare;
      if (this.spareParts[0]) {
        this.createDate = DateToString(this.spareParts[0].createDate);
        this.createUserName = this.spareParts[0].createUserName
      }
    },
    total() {
      this.totalSum = this.total;
    },
    victim() {
      this.victimParticipant = this.victim;
    },
    policyType() {
      this.itemPolicyType = this.policyType;
    },
  },
};
</script>

<style lang="scss" scoped>
.act-form {
  width: 100%;
  padding: 10px;
  // border: 1px solid #eee;
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  color: black;
}

.tables {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

.tables td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.tables th {
  background-color: #dddddd;
}


.finish {
  font-size: 15pt;
  font-weight: bold;
  float: right;
  border: 1px solid black;
  padding: 5px 5px 5px 5px;
}

.tb1 {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 50%;
}

.tb1 td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.tb1 th {
  background-color: #dddddd;
}

td {
  font-family: Cambria;
}

.tb-left-value {
  width: 270px;
}

.tb,
.tbl {
  font-size: 22px;
}

.created {
  font-size: 22px;
}

.act-form table {
  font-size: 21px;
  width: 100%;
}

.act-form table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
  font-size: 23px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  border-radius: 5px;
}

#heading {
  margin-top: 300px !important;
  border-radius: 25px;
}
</style>